import { styled } from '@mui/material';

export const StyledAnchor = styled('a')(({ theme: { fonts } }) => ({
    ...fonts.body_2,
}));
